import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children, roles }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen grid place-items-center bg-xd-bg"><Loader2 className="animate-spin text-xd-orange" size={32} /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    const home = user.role === "admin" ? "/admin" : user.role === "shipper" ? "/shipper" : "/dashboard";
    return <Navigate to={home} replace />;
  }
  return children;
}
